/* eslint-disable camelcase */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiClient from 'src/api/api-client';
import { detailJobURI, getJobURI, upsertJobURI, updateJobStatusURI } from '../api';
import { setValue } from './MessageSlice';

// First, create the thunk
export const fetchJobs = createAsyncThunk(
  'jobs/fetchJobs',
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const response = await apiClient
        .handleRequest({
          method: 'get',
          url: `${getJobURI}`,
          params: { ...params, get_all: true },
        })
        .then(res => res.data);
      return response;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);

export const upsertJob = createAsyncThunk(
  'job/upsertJob',
  async (data, { rejectWithValue, dispatch, getState }) => {
    try {
      const currentPage = 1;
      await apiClient
        .handleRequest({
          method: 'post',
          url: `${upsertJobURI}`,
          data: data.data,
        })
        .then(res => res.data);
      dispatch(fetchJobs({ page: currentPage }));
      return true;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);

export const updateStatusJob = createAsyncThunk(
  'job/updateStatusJob',
  async (data, { rejectWithValue, dispatch, getState }) => {
    try {
      await apiClient.handleRequest({
        method: 'post',
        url: `${updateJobStatusURI(data.id)}`,
        data: { ...data, status: data.status === 'inactive' ? 'active' : 'inactive' },
      });
      dispatch(fetchJobs({ page: 1 }));
      return true;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);

export const updateJob = createAsyncThunk(
  'job/upsertJob',
  async (data, { rejectWithValue, dispatch, getState }) => {
    try {
      const currentPage = 1;
      await apiClient
        .handleRequest({
          method: 'post',
          url: `${detailJobURI(data.id)}`,
          data: data.data,
        })
        .then(res => res.data);
      dispatch(fetchJobs({ page: currentPage }));
      return true;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);

export const detailJob = createAsyncThunk(
  'job/upsertJob',
  async (data, { rejectWithValue, dispatch, getState }) => {
    try {
      const currentPage = 1;
      await apiClient
        .handleRequest({
          method: 'get',
          url: `${detailJobURI(data.id)}`,
        })
        .then(res => res.data);
      dispatch(fetchJobs({ page: currentPage }));
      return true;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);

export const deleteJob = createAsyncThunk(
  'job/upsertJob',
  async (data, { rejectWithValue, dispatch, getState }) => {
    try {
      const currentPage = 1;
      await apiClient
        .handleRequest({
          method: 'delete',
          url: `${detailJobURI(data.id)}`,
        })
        .then(res => res.data);
      dispatch(fetchJobs({ page: currentPage }));
      return true;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);
// Then, handle actions in your reducers:
const jobSlice = createSlice({
  name: 'jobs',
  initialState: {
    entities: [],
    loading: 'idle',
    saving: 'idle',
    currentRequestId: undefined,
    error: null,
    currentPage: 1,
    totalPage: 1,
    total: 0,
  },
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
  },
  extraReducers: {
    [fetchJobs.pending]: (state, action) => {
      if (state.loading === 'idle') {
        state.loading = 'pending';
        state.currentRequestId = action.meta.requestId;
      }
    },
    // Add reducers for additional action types here, and handle loading state as needed
    [fetchJobs.fulfilled]: (state, action) => {
      const { requestId } = action.meta;
      if (state.loading === 'pending' && state.currentRequestId === requestId) {
        const { data, last_page, current_page, total } = action.payload;
        state.loading = 'idle';
        state.entities = data;
        state.currentPage = current_page;
        state.totalPage = last_page;
        state.currentRequestId = undefined;
        state.total = total;
      }
    },
    [fetchJobs.rejected]: (state, action) => {
      const { requestId } = action.meta;
      if (state.loading === 'pending' && state.currentRequestId === requestId) {
        state.loading = 'idle';
        state.error = action.error;
        state.currentRequestId = undefined;
      }
    },

    [upsertJob.pending]: (state, action) => {
      if (state.saving === 'idle') {
        state.saving = 'pending';
        state.currentRequestId = action.meta.requestId;
      }
    },
    [upsertJob.fulfilled]: (state, action) => {
      state.saving = 'idle';
    },
    [upsertJob.rejected]: (state, action) => {
      const { requestId } = action.meta;
      if (state.saving === 'pending' && state.currentRequestId === requestId) {
        state.saving = 'idle';
        state.error = action.error;
        state.currentRequestId = undefined;
      }
    },
  },
});

export default jobSlice.reducer;
